import { InMemoryCache, makeVar } from '@apollo/client';

export const cache = new InMemoryCache({
  typePolicies: {
    Query: {
      fields: {
        theNumber() {
          return theNumberVar();
        },
      }
    },
    Song: {
      keyFields: ["slug"],
    },
/*     Step: {
      keyFields: ["no"],
    } */
  }
});

export const theNumberVar = makeVar(10);
